export const assignment = () => {
  return [
    { text: '     21. ASSIGNMENT', bold: true, style: 'p', },

    { text: "     This TICA shall bind and insure to the benefit of the respective heirs, representative, successors and assigns of the Parties hereto. This TICA may not be assigned by either" +
        " Party without the prior written consent of the other, whose consent may be withheld for any reason or no reason.", style: 'p' },
  ]
}